export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7565.4863c1cd.jpg";